import { PlatformsApi, useAPIQuery } from "melco-shared-logic";

export const useGetPlatform = () => {
    const { data } = useAPIQuery(
        PlatformsApi,
        ["getplatforms"],
        async (api) => {
            let response = await api.platformsList();

            return response;
        }
    );

    return {
        data: data?.list ?? [],
        total: data?.total ?? 0,
        warning_list: data?.warning_list ?? [],
    };
};
